import React, { useContext, useEffect, useState } from 'react';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import RightArrow from "../../../Components/SideBar/assets/icons/right-arrow.png";
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import Button from 'Components/Button/Button';
import DuplicateDay from './DuplicateDay/DuplicateDay';
import EmployeeAllocated from '../BalancingDay/employeeAllocated/EmployeeAllocated';
import { AuthContext } from 'Contexts/auth';

const ProductionDays = (
    {
        onUpdateReloadProductionList,
        onUpdateProductionDaysIdSelecteds,
        onUpdateDecreaseProductionPanelDay,
        productionIdSelecteds,
        productionDaysIdSelecteds,
        decreaseProductionPanelDay,
        onUpdateProductionDays,
        reloadProductionDays,
        handleClose,
        onUpdateShowEmployesDayAllocatedPanel,
        onUpdateEditing
    }) => {
    const { user } = useContext(AuthContext);
    const currentModule = user.module == 'OCMT_PRD_BLCT' || user.module == 'OCMT_PRD_BLCT_QTRZ';

    const [productionDayId, setProductionDayId] = useState(null);
    const [productionDay, setProductionDay] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [totalMinutesPerDay, seTotalMinutesPerDay] = useState(null);

    const [workedMinutes, setWorkedMinutes] = useState(null);
    const [minValueWorked, setMinValueWorked] = useState(null);
    const [completedPieces, setCompletedPieces] = useState(null);
    const [qtdAllocatedEmployee, setQtdAllocatedEmployee] = useState(null);
    const [totalPiecesDay, setTotalPiecesDay] = useState(null);

    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingProductDaysPanel, setLoadingProductDaysPanel] = useState(false);

    const [productDaysList, setProductDaysList] = useState(null)
    const [attributesDetailProductionDayPanel, setAttributesDetailProductionDayPanel] = useState(null);
    const [resetProductionDay, setResetProductionDay] = useState(false);
    const [showPanelDuplicate, setShowPanelDuplicate] = useState(false);
    const [showEmployeeAllocated, setShowEmployeeAllocated] = useState(false);
    const [duplicateDaySelected, setDuplicateDaySelected] = useState(null);
    const [duplicateSourceDayId, setDuplicateSourceDayId] = useState(null);

    const attributeList = [
        { name: "id", value: productionDayId, setter: setProductionDayId },
        { name: "productionDay", value: productionDay, setter: setProductionDay, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "startTime", value: startTime, setter: setStartTime, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "endTime", value: endTime, setter: setEndTime, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "totalMinutesPerDay", value: totalMinutesPerDay, setter: seTotalMinutesPerDay, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "workedMinutes", value: workedMinutes, setter: setWorkedMinutes, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "minValueWorked", value: minValueWorked, setter: setMinValueWorked, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "completedPieces", value: completedPieces, setter: setCompletedPieces, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "qtdAllocatedEmployee", value: qtdAllocatedEmployee, setter: setQtdAllocatedEmployee, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "totalPiecesDay", value: totalPiecesDay, setter: setTotalPiecesDay, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "username", value: username, setter: setUsername, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate, cursor: 'pointer', onDoubleClick: callToDecreaseProductionPanelDay }
    ];

    function callToDecreaseProductionPanelDay() {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            onUpdateDecreaseProductionPanelDay(!decreaseProductionPanelDay)
        }
    }

    async function postProductDays() {
        try {
            setLoadingProductDaysPanel(true)
            const response = await ExecuteAxios.api('post', `/production-day/`, {
                productionId: productionIdSelecteds[0],
                productionDay: productionDay
            });

            if (response) {
                onUpdateProductionDays(true)
                onUpdateReloadProductionList(true)
                setResetProductionDay(true)
            }
            return response;
        } finally {
            setLoadingProductDaysPanel(false)
        }
    }

    async function putProductDays() {
        try {
            setLoadingProductDaysPanel(true)
            const response = await ExecuteAxios.api('put', `/production-day/`, {
                productionDay: productionDay,
                id: productionDayId
            });

            if (response) {
                onUpdateReloadProductionList(true)
                setResetProductionDay(true)
            }

            return response;
        } finally {
            setLoadingProductDaysPanel(false)
        }
    }

    const productionPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        maxHeight: '100%',
        width: '100%'
    };

    const readOnlyAttributes = !(inserting || updating);

    // Avisa a tela para esconder os colaboradores enquanto o dia está em edição
    useEffect(() => {
        onUpdateEditing?.(inserting || updating)
    }, [inserting, updating])

    function callToFetchDataGrid() {
        if (productionIdSelecteds && productionIdSelecteds.length === 1) {
            getProductionRecords(productionIdSelecteds[0])
        } else {
            getProductionRecords(null)
        }
    }

    useEffect(() => {
        callToFetchDataGrid()
    }, [productionIdSelecteds])

    useEffect(() => {
        if (!decreaseProductionPanelDay) {
            callToFetchDataGrid()
            callToFetchDataDetail()
        }
    }, [decreaseProductionPanelDay])

    useEffect(() => {
        callToFetchDataGrid()
    }, [reloadProductionDays])

    useEffect(() => {
        if (!resetProductionDay) {
            return
        }
        setResetProductionDay(false)
        callToFetchDataGrid()
    }, [resetProductionDay])


    async function getProductionRecords(productionIdSelecteds) {
        try {
            const parameters = { productionId: productionIdSelecteds }
            setLoadingProductDaysPanel(true)
            const productDaysList = await ExecuteAxios.api('get', `/production-day/get-production-day-grid/`, { params: parameters });
            setProductDaysList(productDaysList);
            RemoveIdsNotFound.remove(productDaysList, onUpdateProductionDaysIdSelecteds, productionDaysIdSelecteds)
        } finally {
            setLoadingProductDaysPanel(false)
        }
    }

    useEffect(() => {
        callToFetchDataDetail()
    }, [productionDaysIdSelecteds])

    function callToFetchDataDetail() {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            fetchDataDetail(productionDaysIdSelecteds[0])
        } else {
            fetchDataDetail(0)
        }
    }

    const fetchDataDetail = async (productionDaysIdSelected) => {
        const parameters = { id: productionDaysIdSelected }
        const productDaysList = await ExecuteAxios.api('get', `/production-day/get-production-day-detail/`, { params: parameters })
        if (productDaysList) {
            setAttributesDetailProductionDayPanel(productDaysList)
            ApplyAttributes.applyAttributes(productDaysList, attributeList)
        }

        if (!productionDaysIdSelected || productionDaysIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getProductPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateProductionDaysIdSelecteds}
                    idsSelected={productionDaysIdSelecteds}
                    data={productDaysList}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProductionDayPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function deleteProductionDaysSelecteds(recordsSelected) {
        try {
            setLoadingProductDaysPanel(true)
            const parameters = { productionDayId: recordsSelected[0] };
            const response = await ExecuteAxios.api('delete', `/production-day/`, { params: parameters });

            if (response) {
                onUpdateProductionDaysIdSelecteds([])
                onUpdateReloadProductionList(true)
                setResetProductionDay(true)
            }
            return response
        } finally {

            setLoadingProductDaysPanel(false)
        }
    }

    // O dia de origem é escolhido dentro do painel, entre os dias gerados do mesmo produto
    const canDuplicate = productionIdSelecteds && productionIdSelecteds.length === 1;

    function getButtons() {
        return (
            <>
                {currentModule && <Button
                    clickMethod={() => { onUpdateShowEmployesDayAllocatedPanel(true) }}
                    buttonName={'Visualizar alocados'}
                    style={styleAllocatedButton}
                />}
                <Button
                    clickMethod={() => { setShowPanelDuplicate(true) }}
                    buttonName={'Duplicar dia'}
                    style={styleDuplicateButton}
                    disabled={!canDuplicate}
                    readOnly={!canDuplicate}
                />
            </>
        )
    }

    const styleAllocatedButton = {
        width: '150px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    const styleDuplicateButton = {
        width: '100px',
        float: 'right',
        color: !canDuplicate ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    return (
        <>
            <DuplicateDay
                productionId={productionIdSelecteds && productionIdSelecteds[0]}
                showPanelDuplicate={showPanelDuplicate}
                onUpdateShowPanelDuplicate={setShowPanelDuplicate}
                onUpdateLoadingProductDaysPanel={setLoadingProductDaysPanel}
                onUpdateProductionDays={onUpdateProductionDays}
                onUpdateReloadProductionList={onUpdateReloadProductionList}
                onUpdateResetProductionDay={setResetProductionDay}
                duplicateDaySelected={duplicateDaySelected}
                setDuplicateDaySelected={setDuplicateDaySelected}
                sourceDayId={duplicateSourceDayId}
                setSourceDayId={setDuplicateSourceDayId}
                setShowEmployeeAllocated={setShowEmployeeAllocated}
            />
            <EmployeeAllocated
                onUpdateShowEmployeeAllocatedPanel={setShowEmployeeAllocated}
                showEmployeeAllocatedPanel={showEmployeeAllocated}
                productionDaysIdSelected={duplicateSourceDayId}
                productionDayDateToDuplicate={duplicateDaySelected}
            />
            <Panel
                titlePage={'Dias de produção'}
                style={productionPanelStyle}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                canDelete={productionDaysIdSelecteds && productionDaysIdSelecteds.length == 1}
                deleteFunction={deleteProductionDaysSelecteds}
                enableEdit={true}
                enableDelete={true}
                canEdit={productionIdSelecteds && productionIdSelecteds.length === 1 && productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1}
                putFunction={putProductDays}
                enableNewRecord={true}
                canNewRecord={productionIdSelecteds && productionIdSelecteds.length === 1}
                postFunction={postProductDays}
                canViewCRUD={true}
                recordsSelected={productionDaysIdSelecteds}
                viewOnlyOneRecordCRUD={false}
                componentLeftButtons={getButtons()}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailProductionDayPanel}
                attributeList={attributeList}
                componentRightButtons={(updating || inserting) ? null :
                    <button
                        style={{
                            backgroundImage: `url(${RightArrow})`,
                            backgroundSize: '30px 30px',
                            width: '35px',
                            height: '35px',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            alignItems: 'center'
                        }}
                        onClick={handleClose}
                    />
                }
                onUpdateIdSelected={onUpdateProductionDaysIdSelecteds}
            >
                < LoadingIndicator loaded={!loadingProductDaysPanel} >
                    {getProductPanelListOrDetail()}
                </LoadingIndicator >
            </Panel>
        </>
    )

};

export default ProductionDays;
